<template>
  <div class="check-status py-5">
    <spinner v-if="loading"></spinner>
    <div class="container">
      <div class="d-none">
      <b-form-input v-model="taskID" :placeholder="hebrew ? 'הזן מספר' : 'Enter task ID'"></b-form-input>

      <b-btn size="lg" @click="runCheckStatus" variant="primary" class="d-block my-5 mx-auto">{{
        hebrew? 'בדיקת סטטוס'
          : 'Check status'
      }}</b-btn>
      </div>
      <div class="raised-frame bg-white pt-4 pb-5 px-3 mx-auto text-center my-4" v-if="uploadStatus">
        <processing-error v-if="uploadStatus.error && !uploadStatus.msg.includes('does not exist')"></processing-error>
        <process-complete v-else-if="uploadStatus.finish_date && processDaysPassed <= 21"></process-complete>
        <file-missing v-else-if="uploadStatus.finish_date || (uploadStatus.error && uploadStatus.msg.includes('does not exist'))"></file-missing>
        <files-processing v-else-if="uploadStatus.progress_results"></files-processing>
        
               
      </div>
      <router-link class="text-center d-block mt-5" to="/"><small>
          {{ hebrew? 'חזרה לדף הבית': 'Back to home page' }}
        </small></router-link>
    </div>
  </div>
</template>
<script>
import { Actions } from "@/store/stateChanges"
import Spinner from "@/components/spinner"
import FileMissing from "@/components/process/FileMissing"
import FilesProcessing from "@/components/process/FilesProcessing"
import ProcessComplete from "@/components/process/ProcessComplete"
import ProcessingError from "@/components/process/ProcessingError"
import { RunStates } from "@/store/runStates"
export default {
  name: "CheckStatus",
  props: {},
  components: { Spinner, FileMissing, FilesProcessing, ProcessComplete, ProcessingError },
  data() {
    return {
      taskID: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.status) {
        this.taskID = this.$route.query.status
      } 
      else if (this.$route.query.id) {
        this.taskID = this.$route.query.id
      }
      else if (this.jobID) {
        this.taskID = this.jobID
      }
      this.runCheckStatus()
    })
  },
  methods: {
    runCheckStatus() {
      this.$store.commit('SET_JOB_ID', this.taskID)
      this.$store.dispatch(Actions.CHECK_STATUS)
    }
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew;
    },
    jobID() {
      return this.$store.state.jobId
    },
    uploadStatus() {
      return this.$store.state.uploadStatus
    },
    loading() {
      return this.$store.state.morphApiState === RunStates.RUNNING;
    },
    processDaysPassed() {
      const diffTime = Math.abs(new Date() - new Date(this.uploadStatus.finish_date))
      return Math.round(diffTime / (1000 * 60 * 60 * 24))
    }
  }
}
</script>
<style lang="scss">
.check-status {
  .raised-frame {
    max-width: 510px;
    height: 310px;

    h2 {
      font-size: 26px;
      margin-bottom: 17px;
    }

    .progress-wrap {
      margin: 60px auto 36px;

      .progress {

        border-radius: 38px;
        box-shadow: 2px 2px 3px 0 rgb(0 0 0 / 14%);
        border: solid 1px #d8d8d8;
        background-color: #fff;
        height: 28px;

        .progress-bar {
          background-color: #bfe1fe;

        }
      }
    }
  }
}
</style>